const roomBookRouter = () => {
    return [
        {
            path: 'classroom-book',
            name: '教室预定列表',
            component: () => import(/* webpackChunkName: "classroom-book" */ './classroom-book/index.vue'),
        },
    ];
};
export default roomBookRouter;
